import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as getTime from '~/skills/getTime';
import { Dialog } from '@material-ui/core';
import PageTitle from '~/components/PageTitle';
import SearchBar from '~/components/SearchBar';
import { EAA_Item, EAA_ItemContainer, EAA_Row, EAA_TitleText, EAA_Date, EAA_Input, EAA_Btn, EAA_ErrorText, EAA_Area, EAA_Select, EAA_Upload } from '~/components/EditAndAddItem';
import { leftColor, rightColor } from '~/components/EditAndAddItem/common';
import Supple from './Supple';
import Other from './Other';

const modeInfo = {
  add: {
    title: '新增補件',
  },
  edit: {
    title: '編輯補件',
  },
  view: {
    title: '檢視補件',
  },
};

const titleWidth = 140;
const errorLeft = 20 + titleWidth;

class AddAndEdit extends Component {
  constructor (props) {
    super(props);
    this.state = {
      data: JSON.parse(JSON.stringify(props.data)),
      old_data: JSON.parse(JSON.stringify(props.data)),
      mode: '',
      canSend: true,
      errorAry: [],
    };
  }

  _onClose=() => {
    this.props._onClose();
  }

  changeData=({ label = '', data = '' }, func = () => {}) => {
    const { data: body } = this.state;
    const newBody = {
      ...body,
      [label]: data,
    };
    this.setState({ data: newBody }, func);
  }

  getSendBody=() => {
    const { data } = this.state;
    const body = {
      eco_doc_date: data.eco_doc_date || '',
      eco_doc_num: data.eco_doc_num || '',
      eco_doc_upload_files: data.eco_doc_upload_files || [],
      meet_date: data.meet_date || '',
      meet_num: data.meet_num || '',
      meet_doc_upload_files: data.meet_doc_upload_files || [],
      supple_date: data.supple_date || '',
      supple_doc_num: data.supple_doc_num || '',
      supple_doc_upload_files: data.supple_doc_upload_files || [],
      supple_desc: data.supple_desc || '[]',
      other_event: data.other_event || '[]',
    };
    return body;
  }

  add=() => {
    const { onChange } = this.props;
    onChange(this.state.data);
    this._onClose();
  }

  goToCheck=() => this.setState({ mode: 'check' }, () => this.filterError())
  goToEdit=() => this.setState({ mode: '', errorAry: [] });
  edit=() => {
    const { onChange } = this.props;
    onChange(this.state.data);
    this._onClose();
  }

  filterError=() => {
    const { data = {} } = this.state;
    const returnInputValue = t => typeof (t) !== ('undefined') && typeof (t) !== ('object') ? t : '';
    const errorAry = [
      returnInputValue(data.supple_reason) === '', // 0
      data.supple_reason === '會議前依經濟部要求補件' && returnInputValue(data.eco_doc_date) === '', // 1
      data.supple_reason === '會議前依經濟部要求補件' && returnInputValue(data.eco_doc_num) === '', // 2
      data.supple_reason === '會議前依經濟部要求補件' && (data.eco_doc_upload_files || []).length === 0, // 3
      data.supple_reason === '依會議結論補件' && returnInputValue(data.meet_date) === '', // 4
      data.supple_reason === '依會議結論補件' && returnInputValue(data.meet_num) === '', // 5
      data.supple_reason === '依會議結論補件' && (data.meet_doc_upload_files || []).length === 0, // 6
      returnInputValue(data.supple_date) === '', // 7
      returnInputValue(data.supple_doc_num) === '', // 8
      (data.supple_doc_upload_files || []).length === 0, // 9
    ];
    this.setState({ errorAry });
    return errorAry.indexOf(true) !== -1;
  }

  renderDialog=() => {
    const { mode = '', ExtendSupReason = [], list } = this.props;
    const { data = {}, old_data = {}, canSend, errorAry } = this.state;
    const isCheck = this.state.mode === 'check';
    const disabled = mode === 'view' || isCheck;
    const checkChange = label => isCheck ? (data[label] || '') !== (old_data[label] || '') : false;
    const returnInputValue = t => typeof (t) !== ('undefined') && typeof (t) !== ('object') ? t : '';
    const checkFilesChange = label => isCheck ? JSON.stringify(data[label] || []) !== JSON.stringify(old_data[label] || []) : false;
    const allRight = errorAry.indexOf(true) === -1;

    const returnForceOpen = ({ least = 0, most = 0 }) => {
      for (let i = 0; i < errorAry.length; i++) {
        if (i >= least && i <= most && errorAry[i]) return true;
      }
      return false;
    };
    return (
      <div style={{ minWidth: 768, width: '80%', maxHeight: '80%', backgroundColor: 'white', borderRadius: 39, padding: 20, overflowY: 'auto' }}>
        <PageTitle text={modeInfo[mode].title} center />

        <SearchBar text='補件原因' style={{ marginTop: 8 }} defaultOpen forceOpen={returnForceOpen({ least: 0, most: 9 })}>
          <EAA_Row>
            <EAA_Item>
              <EAA_ItemContainer>
                <EAA_TitleText width={titleWidth} bol text='補件原因' haveChange={checkChange('supple_reason')} />
                <EAA_Select disabled={disabled} displayBorder list={ExtendSupReason} value={returnInputValue(data.supple_reason)} onChange={data => this.changeData({ label: 'supple_reason', data })} />
              </EAA_ItemContainer>
              {errorAry[0] && <EAA_ErrorText marginLeft={errorLeft} text='請選擇' />}
            </EAA_Item>
            <EAA_Item />
          </EAA_Row>

          {data.supple_reason === '會議前依經濟部要求補件' && (
            <EAA_Area title='經濟部補件函' color='#186279' backgroundColor='white'>
              <EAA_Row>
                <EAA_Item>
                  <EAA_ItemContainer>
                    <EAA_TitleText width={titleWidth} bol text='公文日期' haveChange={checkChange('eco_doc_date')} />
                    <EAA_Date disabled={disabled} displayBorder value={getTime.returnDate(data.eco_doc_date)} onChange={data => this.changeData({ label: 'eco_doc_date', data: getTime.getType3Time(data) })} />
                  </EAA_ItemContainer>
                  {errorAry[1] && <EAA_ErrorText marginLeft={errorLeft} text='請選擇日期' />}
                </EAA_Item>
                <EAA_Item>
                  <EAA_ItemContainer>
                    <EAA_TitleText width={titleWidth} bol text='公文文號' haveChange={checkChange('eco_doc_num')} />
                    <EAA_Input disabled={disabled} displayBorder unit='字號' value={returnInputValue(data.eco_doc_num)} onChange={data => this.changeData({ label: 'eco_doc_num', data })} />
                  </EAA_ItemContainer>
                  {errorAry[2] && <EAA_ErrorText marginLeft={errorLeft} text='請輸入' />}
                </EAA_Item>
              </EAA_Row>

              <EAA_Row>
                <EAA_Item>
                  <EAA_ItemContainer>
                    <EAA_TitleText width={titleWidth} bol text='上傳檔案' haveChange={checkFilesChange('eco_doc_upload_files')} />
                    <EAA_Upload disabled={disabled} displayBorder value={data.eco_doc_upload_files || []} onChange={data => this.changeData({ label: 'eco_doc_upload_files', data })} />
                  </EAA_ItemContainer>
                  {errorAry[3] && <EAA_ErrorText marginLeft={errorLeft} text='請上傳' />}
                </EAA_Item>
                <EAA_Item />
              </EAA_Row>
            </EAA_Area>
          )}

          {data.supple_reason === '依會議結論補件' && (
            <EAA_Area title='經濟部會議結論函' color='#186279' backgroundColor='white'>
              <EAA_Row>
                <EAA_Item>
                  <EAA_ItemContainer>
                    <EAA_TitleText width={titleWidth} bol text='公文日期' haveChange={checkChange('meet_date')} />
                    <EAA_Date disabled={disabled} displayBorder value={getTime.returnDate(data.meet_date)} onChange={data => this.changeData({ label: 'meet_date', data: getTime.getType3Time(data) })} />
                  </EAA_ItemContainer>
                  {errorAry[4] && <EAA_ErrorText marginLeft={errorLeft} text='請選擇日期' />}
                </EAA_Item>
                <EAA_Item>
                  <EAA_ItemContainer>
                    <EAA_TitleText width={titleWidth} bol text='公文文號' haveChange={checkChange('meet_num')} />
                    <EAA_Input disabled={disabled} displayBorder unit='字號' value={returnInputValue(data.meet_num)} onChange={data => this.changeData({ label: 'meet_num', data })} />
                  </EAA_ItemContainer>
                  {errorAry[5] && <EAA_ErrorText marginLeft={errorLeft} text='請輸入' />}
                </EAA_Item>
              </EAA_Row>

              <EAA_Row>
                <EAA_Item>
                  <EAA_ItemContainer>
                    <EAA_TitleText width={titleWidth} bol text='上傳檔案' haveChange={checkFilesChange('meet_doc_upload_files')} />
                    <EAA_Upload disabled={disabled} displayBorder value={data.meet_doc_upload_files || []} onChange={data => this.changeData({ label: 'meet_doc_upload_files', data })} />
                  </EAA_ItemContainer>
                  {errorAry[6] && <EAA_ErrorText marginLeft={errorLeft} text='請上傳' />}
                </EAA_Item>
                <EAA_Item />
              </EAA_Row>
            </EAA_Area>
          )}

          <EAA_Area title='補件函' color='#186279' backgroundColor='white'>
            <EAA_Row>
              <EAA_Item>
                <EAA_ItemContainer>
                  <EAA_TitleText width={titleWidth} bol text='公文日期' haveChange={checkChange('supple_date')} />
                  <EAA_Date disabled={disabled} displayBorder value={getTime.returnDate(data.supple_date)} onChange={data => this.changeData({ label: 'supple_date', data: getTime.getType3Time(data) })} />
                </EAA_ItemContainer>
                {errorAry[7] && <EAA_ErrorText marginLeft={errorLeft} text='請選擇日期' />}
              </EAA_Item>
              <EAA_Item>
                <EAA_ItemContainer>
                  <EAA_TitleText width={titleWidth} bol text='公文文號' haveChange={checkChange('supple_doc_num')} />
                  <EAA_Input disabled={disabled} displayBorder unit='字號' value={returnInputValue(data.supple_doc_num)} onChange={data => this.changeData({ label: 'supple_doc_num', data })} />
                </EAA_ItemContainer>
                {errorAry[8] && <EAA_ErrorText marginLeft={errorLeft} text='請輸入' />}
              </EAA_Item>
            </EAA_Row>

            <EAA_Row>
              <EAA_Item>
                <EAA_ItemContainer>
                  <EAA_TitleText width={titleWidth} bol text='上傳檔案' haveChange={checkFilesChange('supple_doc_upload_files')} />
                  <EAA_Upload disabled={disabled} displayBorder value={data.supple_doc_upload_files || []} onChange={data => this.changeData({ label: 'supple_doc_upload_files', data })} />
                </EAA_ItemContainer>
                {errorAry[9] && <EAA_ErrorText marginLeft={errorLeft} text='請上傳' />}
              </EAA_Item>
              <EAA_Item />
            </EAA_Row>
          </EAA_Area>
        </SearchBar>

        <Supple disabled={disabled} data={JSON.parse(data.supple_desc || '[]')} changeData={data => this.changeData({ label: 'supple_desc', data: JSON.stringify(data) })} list={list} />
        <Other disabled={disabled} data={JSON.parse(data.other_event || '[]')} changeData={data => this.changeData({ label: 'other_event', data: JSON.stringify(data) })} />

        <div style={{ display: 'flex', marginTop: 36, width: '100%', justifyContent: 'center', marginBottom: 40 }}>
          {mode === 'add' && !isCheck && <EAA_Btn text='取消' backgroundColor={leftColor} onClick={this._onClose} />}
          {mode === 'add' && !isCheck && <EAA_Btn text='確認' backgroundColor={rightColor} onClick={this.goToCheck} style={{ marginLeft: 16 }} />}
          {mode === 'add' && isCheck && <EAA_Btn text='返回編輯' backgroundColor={leftColor} onClick={this.goToEdit} />}
          {mode === 'add' && isCheck && <EAA_Btn text='確認新增' backgroundColor={(allRight && canSend) ? rightColor : 'gray'} onClick={this.add} style={{ marginLeft: 16 }} disabled={!allRight || !canSend} />}
          {mode === 'edit' && !isCheck && <EAA_Btn text='取消' backgroundColor={leftColor} onClick={this._onClose} />}
          {mode === 'edit' && !isCheck && <EAA_Btn text='確認' backgroundColor={rightColor} onClick={this.goToCheck} style={{ marginLeft: 16 }} />}
          {mode === 'edit' && isCheck && <EAA_Btn text='返回編輯' backgroundColor={leftColor} onClick={this.goToEdit} />}
          {mode === 'edit' && isCheck && <EAA_Btn text='確認修改' backgroundColor={(allRight && canSend) ? rightColor : 'gray'} onClick={this.edit} style={{ marginLeft: 16 }} disabled={!allRight || !canSend} />}
          {mode === 'view' && <EAA_Btn text='返回' backgroundColor={leftColor} onClick={this._onClose} />}
        </div>
      </div>
    );
  }

  render () {
    return (
      <Dialog
        PaperComponent={this.renderDialog}
        open={true}
      />
    );
  }
}

const mapStateToProps = state => ({
  ExtendSupReason: state.data.ExtendSupReason,
});
const mapDispatchToProps = dispatch => ({

});

export default connect(mapStateToProps, mapDispatchToProps)(AddAndEdit);
